"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _isPropertyChanged = _interopRequireDefault(require("./isPropertyChanged"));

var _isOrderedMapPropertyChanged = _interopRequireDefault(require("./isOrderedMapPropertyChanged"));

var _isNestedPropertyChanged = _interopRequireDefault(require("./isNestedPropertyChanged"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _reselect = require("reselect");

var _default = function _default(_ref) {
  var properties = _ref.properties,
      currentSelector = _ref.currentSelector,
      nextSelector = _ref.nextSelector;
  return (0, _reselect.createSelector)([currentSelector, nextSelector], function (current, next) {
    if (current) {
      return properties.find(function (property) {
        if (typeof property === "string") {
          return (0, _isPropertyChanged.default)(current.get(property), next.get(property));
        } else if ((0, _typeof2.default)(property) === "object" && property.type) {
          if (property.type === _PropertyTypes.default.SIMPLE) {
            return (0, _isPropertyChanged.default)(current.get(property.key), next.get(property.key));
          } else if (property.type === _PropertyTypes.default.ORDERED_MAP) {
            return (0, _isOrderedMapPropertyChanged.default)({
              current: current.get(property.key),
              next: next.get(property.key)
            });
          } else if (property.type === _PropertyTypes.default.NESTED) {
            return (0, _isNestedPropertyChanged.default)({
              property: property,
              currentValue: current.get(property.key),
              nextValue: next.get(property.key)
            });
          }
        }

        return false;
      }) !== undefined;
    }

    return false;
  });
};

exports.default = _default;
module.exports = exports.default;